import { createFileRoute } from '@tanstack/react-router'
import { stpBulkJob } from '@/lib/queries/stp-bulk-jobs'
import { vtoBulkJob } from '@/lib/queries/vto-bulk-jobs'
import { BulkJobListPage } from '@/features/workspaces/bulk'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/bulk-jobs/'
)({
  loader: async ({ context, params }) => {
    await Promise.all([
      context.queryClient.query({
        ...stpBulkJob.findManyByWorkspace(params.workspaceId),
        staleTime: 'static',
      }),
      context.queryClient.query({
        ...vtoBulkJob.findManyByWorkspace(params.workspaceId),
        staleTime: 'static',
      }),
    ])
  },
  component: BulkJobListPage,
})
